export const poShipmentsByReqId = (reqLineId, posForReqLine) => {
    /* Parse the output of the GET_POS_BY_REQ_LINE_ID (src.services/procurement/urls)
    api to produce a distinct list of PO shipments per req line ID

    Arguments
    ---------
    reqLineId : string
    posForReqLine : array

    Returns
    -------
    array
    */
    const posForReqLineCleansed = posForReqLine || [];
    // Loop through all POs
    const shipments = posForReqLineCleansed.reduce((acc, po) => {
        const poLines = po?.poLines || [];
        // Loop through all PO lines
        const poShipments = poLines.reduce(
            (associatedShipmentsPerLine, poLine) => {
                const poShipments = poLine?.poLocations || [];
                // Loop through all PO shipments
                const associatedShipments = poShipments.filter((poShipment) => {
                    const poDists = poShipment?.poDist || [];
                    // Loop through all distributions, retrieving only those tagged to `reqLineId`
                    const doesDistArrayContainReqLineId = poDists.some(
                        (dist) => dist?.IBUY_REQ_LINE_REF == reqLineId
                    );
                    return doesDistArrayContainReqLineId;
                });
                return [...associatedShipmentsPerLine, ...associatedShipments];
            },
            []
        );
        return [...acc, ...poShipments];
    }, []);
    // Take distinct shipments only
    const uniqueShipments = [...new Set(shipments)];
    return uniqueShipments;
};

export const getReqsAssociatedWithPO = (poData) => {
    /* Extract distinct iBuy requisition IDs from a nested PO payload

    Arguments
    ---------
    poData : obj
        A nested PO object, including lines, locations and distributions.

    Returns
    -------
    array   
        Distinct list of iBuy requisitions tagged in the input PO

    */
    const uniqueReqIds = new Set();
    const poLines = poData?.poLines || [];

    // Loop through all PO lines
    for (const poLine of poLines) {
        const poLocations = poLine?.poLocations || [];

        // Loop through all PO locations (shipments)
        for (const poLocation of poLocations) {
            const poDists = poLocation?.poDist || [];

            // Loop through all PO distributions
            for (const poDist of poDists) {
                const reqLineId = poDist?.IBUY_REQ_LINE_REF;
                if (!reqLineId) {
                    continue;
                }

                const [reqId] = reqLineId.split("_");
                if (reqId) {
                    uniqueReqIds.add(reqId);
                }
            }
        }
    }

    return [...uniqueReqIds];
};
